<template>
  <div class="breadcrumbs">
    <ul>
      <li v-for="(l, id) in links" :key=id>
        <router-link
          v-if="id<links.length-1"
          :to="{name: l.name, params: l.params}"
        >
          {{l.meta.pageName}}
        </router-link>
        <span v-else>{{l.meta.pageName | textTrim(8)}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumbs',
  data () {
    return {
    }
  },
  props: {
    links: Array
  },
  computed: {
  },
  mounted () {
  },
  filters: {
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    }
  },
  methods: {

  },
  components: {
  }
}
</script>
<style scoped>
ul {
  padding-left:16px !important;
}
li {
  list-style: none;
}
.breadcrumbs {
width: 100%;
margin: 10px auto 10px auto;
}
.breadcrumbs ul {
display: table;
font-size: 13px;
}
.breadcrumbs ul li {
margin: 0 10px 0 0;
font-size: 13px;
float: left;
}
.breadcrumbs ul li:first-child::before {
padding: 0 3px 0 0;
content: " ";
font-family: FontAwesome;
font-size: 14px;
}
.breadcrumbs ul li::before {
padding: 0 10px 0 0;
content: ">";
font-family: FontAwesome;
font-size: 14px;
}
</style>
